import { createContext, useContext } from "react";
import { QuoteCopy } from "./QuoteCopy";

const QuoteCopyContext = createContext<QuoteCopy>(QuoteCopy.english());

export const QuoteCopyProvider = QuoteCopyContext.Provider;

export function useQuoteCopy(): QuoteCopy {
  return useContext(QuoteCopyContext);
}
